// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchBeginLoadShipTos } from "@insite/client-framework/Store/Pages/Addresses/Handlers/LoadShipTos";

// XNG-Changes: fetch currentBillTo as ShipTo
// (OOTB Behavior excludes currentBillTo from shipTo in the addresses page)

export const XngDispatchBeginLoadShipTos: typeof DispatchBeginLoadShipTos = props => {
    props.dataViewParameter = {
        ...props.getState().pages.addresses.getShipTosParameter,
        exclude: ["showAll", "oneTime"],
    };
    props.dispatch({
        type: "Data/ShipTos/BeginLoadShipTos",
        parameter: props.dataViewParameter,
    });
};

replaceInChain(chain, DispatchBeginLoadShipTos, XngDispatchBeginLoadShipTos);
